import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ChangeCustomerContact, CustomerContactsState } from "../shared/models/customerContactsModels";
import customerContactsApi from "./api/customerContactsApi";

export const getContacts = createAsyncThunk(
  "customerContacts/getContacts",
  async () => {
    return customerContactsApi.getContacts();
  }
);

export const createContact = createAsyncThunk(
  "customerContacts/createContact",
  async (model: ChangeCustomerContact) => {
    return customerContactsApi.createContact(model);
  }
);

export const changeContact = createAsyncThunk(
  "customerContacts/editContact",
  async ({ id, model }: any) => {
    return customerContactsApi.changeContact(id, model);
  }
);

export const getContact = createAsyncThunk(
  "customerContacts/getContact",
  async (id: string) => {
    return customerContactsApi.getContact(id);
  }
);

export const deleteContact = createAsyncThunk(
  "customerContacts/deleteContact",
  async (id: string) => {
    return customerContactsApi.deleteContact(id);
  }
);

export const changeDefaultContact = createAsyncThunk(
  "customerContacts/changeDefaultContact",
  async (id: string) => {
    return customerContactsApi.changeDefaultContact(id);
  }
);

const initialState: CustomerContactsState = {
  contacts: undefined,
  contact: undefined,
  loading: false,
  success: undefined,
  error: undefined
};

const customerContactsSlice = createSlice({
  name: "customerContacts",
  initialState: initialState,
  reducers: {
    selectContact: (state, action) => {
      state.contact = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getContacts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContacts.fulfilled, (state, { payload }) => {
        state.contacts = payload;
        state.loading = false;
      })
      .addCase(getContacts.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContact.fulfilled, (state, { payload }) => {
        state.contact = payload;
        state.loading = false;
      })
      .addCase(getContact.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(createContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(createContact.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(createContact.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(changeContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeContact.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(changeContact.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(changeDefaultContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeDefaultContact.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(changeDefaultContact.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(deleteContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteContact.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(deleteContact.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });
  }
});

export const {
  selectContact,
  setSuccess,
  setLoading,
  setError
} = customerContactsSlice.actions;

export default customerContactsSlice.reducer;